// BookTickets/stages/PaymentProcess/lib/paymentUrls.ts

export function buildPaypalReturnUrls(args: { pathname: string; cartId: string }) {
  const origin = typeof window !== 'undefined' ? window.location.origin : ''

  const successQs = new URLSearchParams()
  successQs.set('cartId', args.cartId)
  successQs.set('paymentMethod', 'paypal')

  const errorQs = new URLSearchParams()
  errorQs.set('error', 'true')

  return {
    successUrl: `${origin}${args.pathname}?${successQs.toString()}`,
    errorUrl: `${origin}${args.pathname}?${errorQs.toString()}`,
  }
}
